<template>
  <div
    v-if="checkedIn && !dismissed"
    class="d-none d-md-flex align-items-center bg-white border"
    style="position:fixed;top:16px;right:16px;z-index:1030;border-radius:20px;padding:6px 10px 6px 14px;border-color:#e9ecef !important;box-shadow:0 2px 8px rgba(0,0,0,.06);font-size:12px;"
  >
    <span class="rounded-circle bg-dark d-inline-block mr-2" style="width:6px;height:6px;"></span>
    <span class="text-dark">Checked in at {{ checkInTime }}</span>
    <button
      type="button"
      class="btn btn-link text-muted p-0 ml-2 d-flex align-items-center"
      style="font-size:14px;line-height:1;"
      aria-label="Dismiss"
      @click="dismiss"
    ><i class="bi bi-x"></i></button>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

const DISMISSED_UNTIL_KEY = "attendance_indicator_dismissed_until";

// Purely informational — "dukakit knows I am here." No action required
// beyond dismissing it. Attendance itself is recorded automatically by the
// backend activity pipeline (see AttendanceLoggingService); this only
// reflects it.
export default {
  name: "AttendanceIndicator",
  data() {
    return {
      checkedIn: false,
      checkIn: null,
      dismissed: false,
    };
  },
  computed: {
    checkInTime() {
      return this.checkIn ? moment(this.checkIn).format("h:mm A") : "";
    },
  },
  methods: {
    fetchStatus() {
      axios
        .get("/api/attendance/today")
        .then((res) => {
          this.checkedIn = !!res.data.checked_in;
          this.checkIn = res.data.check_in || null;
        })
        .catch(() => {});
    },
    dismiss() {
      this.dismissed = true;
      try {
        // Stored as "tomorrow, midnight" rather than today's date, so a
        // dismissal made just before midnight doesn't immediately expire.
        localStorage.setItem(DISMISSED_UNTIL_KEY, moment().add(1, "day").startOf("day").toISOString());
      } catch (e) { /* localStorage unavailable (private mode, etc.) — dismissal just won't persist */ }
    },
    isDismissedForToday() {
      try {
        const until = localStorage.getItem(DISMISSED_UNTIL_KEY);
        return !!until && moment().isBefore(moment(until));
      } catch (e) {
        return false;
      }
    },
  },
  mounted() {
    this.dismissed = this.isDismissedForToday();
    this.fetchStatus();
    // A meaningful action taken just after mount (e.g. completing a sale)
    // can flip check-in state within the same visit — refresh occasionally
    // rather than only once per page load.
    this.poll = setInterval(this.fetchStatus, 5 * 60 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.poll);
  },
};
</script>
